import {useSelector} from 'react-redux'
import {selectAllTags} from '../state/accountTagsSlice'

const usePermissions = ()=>{
	return {
		assessmentList:true,
		assessment:true,
		diet:true,
		nutrition:true,
		exercise:true,
		food:true,
		task:true,
		workout:true,
	}
}
/*
const usePermissions = ()=>{
	const {
		assessmentList,
		assessment,
		exercise,
		workout,
		diet,
		food,
		task,
	} = useSelector(state=>(
		state.users.current_user.edit_permissions
	))
	return {
		assessmentList: assessmentList === "1",
		assessment: assessment === "1",
		diet: diet === "1",
		nutrition: diet === "1",
		exercise: exercise === "1",
		food: food === "1",
		task: task === "1",
		workout: workout === "1",
	}
}

export default usePermissions
*/
export default usePermissions